import { get } from 'data/services/apiService';
import { API_URL } from 'data/services/apiConstants';

const GET_AKAS_REQUEST = 'GET_AKAS_REQUEST';
const GET_AKAS_SUCCESS = 'GET_AKAS_SUCCESS';
const GET_AKAS_ERROR = 'GET_AKAS_ERROR';

const initialState = {
  propertyId: null,
  akas: [],
  isLoading: false,
  hasError: false,
  error: null,
};

export const fetchAkas = (propertyId) => (dispatch, getState) => {
  // Frontend only fetches AKAs - persistence is handled by the CheckPropertyAka command
  const url = `${API_URL}/api/property/${propertyId}/akas?force=false&persist=false`;
  dispatch(getAkasRequest(propertyId));
  // Debug log for network tracing
  return get({
    dispatch,
    url,
    onSuccess: (result) => {
      // result is expected as { propertyId, akas: [...] }
      const akas = result?.akas || [];
      dispatch(getAkasSuccess(propertyId, akas));
    },
    onError: (error) => dispatch(getAkasError(error)),
  });
};

export const getAkasRequest = (propertyId) => ({
  type: GET_AKAS_REQUEST,
  payload: {
    propertyId,
    isLoading: true,
    hasError: false,
    error: null,
  },
});

export const getAkasSuccess = (propertyId, akas) => ({
  type: GET_AKAS_SUCCESS,
  payload: {
    propertyId,
    isLoading: false,
    hasError: false,
    akas,
    error: null,
  },
});

export const getAkasError = (error) => ({
  type: GET_AKAS_ERROR,
  payload: {
    isLoading: false,
    hasError: true,
    error,
  },
});

const akaReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_AKAS_REQUEST:
    case GET_AKAS_SUCCESS:
    case GET_AKAS_ERROR:
      if (action.type === GET_AKAS_ERROR) {
        // eslint-disable-next-line no-console
        console.warn('[AKA] fetch error', action.payload?.error);
      }
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default akaReducer;
